import * as bulmaToast from "bulma-toast";

bulmaToast.setDefaults({
  dismissible: true,
  pauseOnHover: true,
  position: "top-center",
  duration: 5000
});

export default bulmaToast.toast;